import React, { FC, Suspense, useEffect } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';
import { AppNodeMode, MiniApplicationManifest } from '../../core/helpers/dna';
import { slices } from '../../shared/reducers/slices';
import styled from 'styled-components';
import { GlobalWhiteStyle } from './styles';
import { ApplicationTheme } from '../../shared/themes';
import { HSEDeziignNavBar } from 'shared/navbars/HSEDeziiignNavbar';
import CommdesignFooter from 'shared/components/Footer/CommdesignFooter';
import LoadingPage from 'shared/pages/loading/LoadingPage';
import { getRoutesList } from './routesList';
import { PrivateRoute } from 'core';
import { RouteHistoryTracker } from 'RouteHistoryTracker';
import FixedFooter from 'shared/components/Footer/FixedFooter';

const manifest: MiniApplicationManifest = {
  // Название мини-приложения - и document.title
  title: 'HSE University',

  // объект редукторов (redux)
  reducer: slices,

  // авторизация
  auth: {
    productionClientId: '',
    developClientId: '',
    service: 'dezign',
  },

  theme: ApplicationTheme.white,
};

/**
 * The main wrapper
 */
export const AppWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 100vw;
  background: ${(p) => p.theme.mainBg};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const AppContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;

/**
 * App container
 */
export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

/**
 * Приложение. Это точка входа. Все начинается отсюда.
 * Провайдеры, оформление страницы - да все, что угодно!
 *
 * Любое свершение начинается с точки входа - удачного кодинга :)
 *
 * Переменная `mode` может принимать 3 значения: 'develop', 'staging' и 'production'
 */
const App: FC<{ mode: AppNodeMode }> = () => {
  return (
    <>
    <GlobalWhiteStyle/>
    <AppWrapper className="app-wrapper">
      <AppContainer>
        <AppContent className="app-content">
          <ScrollTopFix/>
              <HSEDeziignNavBar/>
          <div id={'navbar-portal'}/>
          <Routes />
          {window.location.pathname === "/school/commdesign/2" && <CommdesignFooter/>}
        </AppContent>
        <FixedFooter />
      </AppContainer>
    </AppWrapper>
  </>
  )
};

/**
 * Компонент роутера - обязательная часть ядра Geograffee
 *
 * Отсюда маршрутизация по мини-приложению
 */

export const Routes: FC<{ lang?: string }> = ({ lang = 'en' }) => (
  <Suspense fallback={<LoadingPage/>}>
    <RouteHistoryTracker />
    <Switch>
      {
        getRoutesList({context: 'amschoolportfolio' }).map((routeItem: any) => {
            const RouteComponent = routeItem.isPrivate ? PrivateRoute : Route
            const renderedComponent = routeItem.redirectTo 
              ? () => <Redirect to={routeItem.redirectTo}/> 
              : routeItem.component
            return <RouteComponent
                path={routeItem.path}
                key={routeItem.path}
                component={renderedComponent}
                exact={routeItem.exact}
            />
        })
      }
    </Switch>
  </Suspense>
);

/**
 * React-router mini - utility
 * @deprecated Will be removed after time
 */
export function ScrollTopFix() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, [pathname]);

  return null;
}

// Это обязательная часть. Она очень важна!
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  App,
  manifest,
};
import React, { FC, Suspense, useEffect } from 'react';
import { Route, Switch, useLocation, Redirect } from 'react-router-dom';
import { AppNodeMode, MiniApplicationManifest } from '../../core/helpers/dna';
import { slices } from '../../shared/reducers/slices';
import styled from 'styled-components';
import { GlobalWhiteStyle } from './styles';
import { ApplicationTheme } from '../../shared/themes';
import { HSEDeziignNavBar } from 'shared/navbars/HSEDeziiignNavbar';
import CommdesignFooter from 'shared/components/Footer/CommdesignFooter';
import LoadingPage from 'shared/pages/loading/LoadingPage';
import { getRoutesList } from './routesList';
import { PrivateRoute } from 'core';
import { RouteHistoryTracker } from 'RouteHistoryTracker';
import FixedFooter from 'shared/components/Footer/FixedFooter';

const manifest: MiniApplicationManifest = {
  // Название мини-приложения - и document.title
  title: 'HSE University',

  // объект редукторов (redux)
  reducer: slices,

  // авторизация
  auth: {
    productionClientId: '',
    developClientId: '',
    service: 'dezign',
  },

  theme: ApplicationTheme.white,
};

/**
 * The main wrapper
 */
export const AppWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 100vw;
  background: ${(p) => p.theme.mainBg};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const AppContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
`;

/**
 * App container
 */
export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

/**
 * Приложение. Это точка входа. Все начинается отсюда.
 * Провайдеры, оформление страницы - да все, что угодно!
 *
 * Любое свершение начинается с точки входа - удачного кодинга :)
 *
 * Переменная `mode` может принимать 3 значения: 'develop', 'staging' и 'production'
 */
const App: FC<{ mode: AppNodeMode }> = () => {
  return (
    <>
    <GlobalWhiteStyle/>
    <AppWrapper className="app-wrapper">
      <AppContainer>
        <AppContent className="app-content">
          <ScrollTopFix/>
              <HSEDeziignNavBar/>
          <div id={'navbar-portal'}/>
          <Routes />
          {window.location.pathname === "/school/commdesign/2" && <CommdesignFooter/>}
        </AppContent>
        <FixedFooter />
      </AppContainer>
    </AppWrapper>
  </>
  )
};

/**
 * Компонент роутера - обязательная часть ядра Geograffee
 *
 * Отсюда маршрутизация по мини-приложению
 */

export const Routes: FC<{ lang?: string }> = ({ lang = 'en' }) => (
  <Suspense fallback={<LoadingPage/>}>
    <RouteHistoryTracker />
    <Switch>
      {
        getRoutesList({context: 'amschoolportfolio' }).map((routeItem: any) => {
            const RouteComponent = routeItem.isPrivate ? PrivateRoute : Route
            const renderedComponent = routeItem.redirectTo 
              ? () => <Redirect to={routeItem.redirectTo}/> 
              : routeItem.component
            return <RouteComponent
                path={routeItem.path}
                key={routeItem.path}
                component={renderedComponent}
                exact={routeItem.exact}
            />
        })
      }
    </Switch>
  </Suspense>
);

/**
 * React-router mini - utility
 * @deprecated Will be removed after time
 */
export function ScrollTopFix() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });
  }, [pathname]);

  return null;
}

// Это обязательная часть. Она очень важна!
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  App,
  manifest,
};
